import { colors } from 'Constants/Colors';
import { makeStyles } from '@mui/styles';
import '@fontsource/metropolis';

const textFieldStyles = makeStyles(theme => ({
  disabled: {
    '& .MuiInputLabel-root': {
      fontFamily: 'var(--app-font)',
    },
    '& .MuiOutlinedInput-root': {
      background: colors.GRAY_TEXT_FIELD,
      '& .MuiOutlinedInput-input': {
        WebkitTextFillColor: 'black',
        fontFamily: 'var(--app-font)',
        fontWeight: 'bold',
      },
    },
  },
  enabled: {
    '& .MuiInputLabel-root': {
      fontFamily: 'var(--app-font)',
    },
    '& .MuiOutlinedInput-root': {
      background: 'white',
      '& .MuiOutlinedInput-input': {
        WebkitTextFillColor: 'black',
        fontFamily: 'var(--app-font)',
      },
    },
  },
  input: {
    color: 'red',
  },
}));

export default {
  textFieldStyles,
  container: {
    width: '100%',
    background: '#f6f7fc',
    height: '100vh',
    alignItems: 'center',
  },
  header: {
    fontFamily: 'var(--app-font)',
    marginTop: '0',
    marginBottom: '4%',
    color: colors.GRAY_HEADER,
  },
  textField: {
    marginBottom: '5%',
  },
  grayedSubmit: {
    textTransform: 'none',
    fontFamily: 'var(--app-font)',
    fontWeight: 'bold',
    fontSize: '20px',
    backgroundColor: colors.GRAY_SUBMIT,
    color: '#FFF',
    paddingLeft: '20%',
    paddingRight: '20%',
    paddingTop: '1%',
    paddingBottom: '1%',
    marginTop: '5%',
  },
  enabledSubmit: {
    textTransform: 'none',
    fontFamily: 'var(--app-font)',
    fontWeight: 'bold',
    fontSize: '20px',
    backgroundColor: '#00984A',
    color: '#FFF',
    paddingLeft: '20%',
    paddingRight: '20%',
    paddingTop: '1%',
    paddingBottom: '1%',
    marginTop: '5%',
  },
  editIconContainer: {
    alignSelf: 'flex-end',
    marginRight: '1%',
    marginTop: '3%',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '45%',
  },
  icon: {
    backgroundColor: '#14A037',
    color: '#FFF',
    borderRadius: 30,
    padding: 6,
    height: 35,
    width: 35,
  },
  emptyDiv: {
    marginTop: '3%',
    padding: 6,
    height: 51,
  },
};
